// @flow
import { reducer as formReducer } from 'redux-form';
import { flow, map, take, takeRight } from 'lodash/fp';
import {
    INSTALL_HUB_FORM_NAME,
    INSTALL_HUB_FORM_FIELD_NAME,
    UPGRADE_NANO1_HUB_FORM_NAME,
    UPGRADE_NANO1_HUB_FORM_FIELD_NAME,
    CHANGE_PIN_FORM_NAME
} from '~/core/state/form/constants';

const normalizeLettersNumbers = map(field => ({
    ...field,
    value: /^[a-z0-9]{1}$/i.test(field.value) ? field.value.toUpperCase() : ''
}));
const normalizeNumbers = map(field => ({
    ...field,
    value: /^[0-9]{1}$/i.test(field.value) ? field.value : ''
}));
const normalizeFirstThree = flow(take(3), normalizeLettersNumbers);
const normalizeLastThree = flow(takeRight(3), normalizeNumbers);
const normalizePin = (value, previousValue) => {
    if (!value) {
        return value;
    }

    return /^[0-9]{0,4}$/i.test(value) ? value : previousValue;
};

export default formReducer.normalize({
    [INSTALL_HUB_FORM_NAME]: {
        [`${INSTALL_HUB_FORM_FIELD_NAME}[]`]: values =>
            values && [...normalizeFirstThree(values), ...normalizeLastThree(values)]
    },
    [UPGRADE_NANO1_HUB_FORM_NAME]: {
        [`${UPGRADE_NANO1_HUB_FORM_FIELD_NAME}[]`]: values =>
            values && [...normalizeFirstThree(values), ...normalizeLastThree(values)]
    },
    [CHANGE_PIN_FORM_NAME]: {
        pin: normalizePin,
        confirm: normalizePin
    }
});



// WEBPACK FOOTER //
// ./src/core/state/form/index.js